module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-Bold.9a680374.ttf";